<template>
  <div class="header">
    <h2>Purchase Shipping Containers</h2>
    <h4>
      Enter the {{ COUNTRY_CODE }} postal code where your shipping container(s)
      will be delivered
    </h4>
    <br />
    <h4 class="font-weight-normal ma3" v-if="COUNTRY_CODE === 'US'">
      Click
      <a style="color: #6dbe45" :href="countryDomains.countrybased_href"
        >here</a
      >
      if you're in {{ countryDomains.countryName }}
      <img width="20px" :src="countryDomains.flag_src" />
    </h4>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "HomeHeader",
  computed: {
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
    }),
  },
  data() {
    return {
      countryDomains: {
        flag_src: "",
        countrybased_href: "",
        countryName: "",
      },
    };
  },
  mounted() {
    this.initializeCounrtyURLs();
  },
  methods: {
    initializeCounrtyURLs() {
      //Assign flag and country based URLs.
      if (this.COUNTRY_CODE === "US") {
        this.countryDomains["flag_src"] =
          "https://catamphetamine.gitlab.io/country-flag-icons/3x2/CA.svg";
        this.countryDomains["countrybased_href"] =
          "https://sale.northerncontainersales.ca/";
        this.countryDomains["countryName"] = "Canada";
      }
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 25px;
  color: #ffffff;
  font-weight: bold;
}

h4 {
  font-size: 17px;
  color: #ffffff;
  font-weight: bold;
}

.header {
  width: 70%;
  margin: auto;
  margin-top: 100px;
}

@media only screen and (max-width: 550px) {
  .header {
    width: 100%;
  }
}
</style>
